
function FormattedBandwidth(props) {
    const bw_k = props.bandwidth / 1024;
    const bw_m = bw_k / 1024;

    if (bw_m >= 1) {
        return Math.round(bw_m * 100) / 100 + " MiB/s";
    } else if (bw_k >= 1) {
        return Math.round(bw_k * 100) / 100 + " KiB/s";
    }

    return props.bandwidth + " B/s";
}

export default FormattedBandwidth;
